import ContentLoader from 'react-content-loader';

const RectangleSkeleton = ({
  width,
  height,
  rx = 8,
  ry = 8,
}: {
  width: number | string;
  height: number | string;
  rx?: number;
  ry?: number;
}) => {
  return (
    <div>
      <ContentLoader
        speed={2}
        width={width}
        height={height}
        viewBox={`100 100 ${width} ${height}`}
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb"
        animate={true}
        style={{width: '100%'}}>
        <rect x="0" y="0" rx={rx} ry={ry} width={width} height={height} />
      </ContentLoader>
    </div>
  );
};

export default RectangleSkeleton;
